import * as angular from "angular";


angular
  .module('bringoz.admin.commons')
  .filter('bringozPrefs', bringozPrefs);

function bringozPrefs() {
  return function bringozDateFilter(value) {
    return value === true ? 'ON' : (value === false ? 'OFF' : 'Site Default');
  }
}
